export default {
  home: {
    minute: "minuta",
    price_info:
      "Prvih {mianfei} minuta je besplatno. Maksimalna cijena za 24 sata iznosi {currencyName}{fengding}. Power bank se može vratiti na bilo koju {appName} stanicu.",
    price_info_0: "USB C i Lightning kabl uključeni.",
    price_info_1:
      "Ako se power bank ne vrati u roku od {pOvertimeDay} dana, smatraće se kupljenim za iznos depozita.",
    price_info_2:
      "Preporučujemo vraćanje power banka na istu lokaciju na kojoj je iznajmljen. Preuzmite aplikaciju ili skenirajte QR kod na poleđini uređaja da vidite sve {appName} lokacije.",
    feature_1: "Uključuje sve tipove kablova: iPhone, Type‑C",
    feature_2: "Može se vratiti na bilo kojoj stanici",
    feature_3: "Dostupno bežično punjenje",
    tips_1: "Vaš depozit od {currencyName}{yajin} biće vraćen na kraju najma",
    tips_2:
      "Depozit za punjenje {currencyName}{yajin} može se koristiti za najam, a kada se potroši može biti refundiran",
    tips_3:
      "Trenutni saldo je {currencyName}{myyue}, koji se može direktno koristiti za najam",
    submit: "Započni najam",
    borrow: "Iznajmi",
    msg_fail_title: "Greška",
    msg_fail_content: "Najam nije uspio, pokušajte ponovo",
    msg_rentcount: "Trenutno imate {zujieNum} nezatvorenih narudžbi",
    goborrow: "Idi na punjenje!!!",
    nearby: "Pogledaj najbliže stanice",
    preauth: "Pre‑autorizacija",
    nearbyvenues: "Obližnje lokacije",
    borrow_tips:
      "Sigurnost plaćanja kreditnim karticama / Izjava o privatnosti / Uslovi korištenja",
    company_address: "Muamera Onerbegovića 3, 71000 Sarajevo",
    company_phone: "0038762701640",
    company_email: "info@chargi.ba",
    company_id: "ID broj: 4203351730008",
    company_vat: "PDV broj: 203351730008",
    company_name: "ITGen d.o.o."
  },
  login: {
    welcome: "Dobrodošli u {appname}",
    code_title: "verifikacija",
    phone_number: "Broj telefona",
    verification_email: "Unesite svoju adresu e‑pošte",
    verification_code: "Unesite verifikacijski kod",
    captcha_code: "Kod",
    send_code: "Pošalji kod",
    login: "Prijava",
    agree: "Klikom na Prijava slažete se sa ",
    readme: "Korisničkim ugovorom",
    msg_fail_login: "Prijava nije uspjela",
    msg_success_login: "Prijava uspješna",
    msg_fail_user:
      "Greška pri dobijanju korisničkih informacija. Želite li pokušati ponovo?",
    sign_in_with: "Prijavite se pomoću",
    no_sms: "Niste primili SMS poruku",
    retry: "Ponovo pošalji",
    email: "E‑pošta"
  },
  confirm: {
    deletecard: "Izbriši karticu",
    addcard: "Unesite podatke o kartici",
    title: "Potvrda plaćanja",
    paynow: "Odmah plati",
    SMSConfirm:
      "Molimo da izvršite plaćanje prema tekstualnoj poruci primljenoj na telefon i kliknete dugme Potvrdi da nastavite.",
    pay_label: "Iznos",
    auth_label: "Pre‑autorizacija",
    price_tips:
      "Vaš saldo se može povući na zahtjev. Može potrajati 1‑5 radnih dana dok se ne pojavi na vašem računu.",
    auth_tips:
      "Potrebna je pre‑autorizacija u iznosu {0}{1}. Stvarni iznos najma biće naplaćen kada se power bank vrati.",
    pay_type: "Odaberite željeni način plaćanja",
    submit: "Potvrdi plaćanje",
    msg_loading: "Učitavanje...",
    msg_fail_title: "Upozorenje",
    msg_fail_payment: "Neuspjelo pokretanje plaćanja depozita",
    msg_fail_order: "Kreiranje narudžbe najma nije uspjelo",
    msg_fail_support: "Sistem nije podržan",
    msg_fail_confirm: "Potvrdi",
    msg_fail_retry: "Pokušaj ponovo",
    msg_fail_cancel: "Otkaži",
    payment_agreement: "Slažem se i prihvatam uslove kupovine",
    payment_agreement_tips: "Molimo označite da se slažete s uslovima kupovine"
  },
  mine: {
    title: "Korisnički profil",
    wallet: "Moj novčanik",
    balance: "Moj balans",
    deposit: "Depozit",
    wallet_in: "Uplata",
    wallet_out: "Isplata",
    wallet_log: "Evidencija novčanika",
    rental_history: "Istorija iznajmljivanja",
    payment_title: "Načini plaćanja",
    download_app: "Preuzmi aplikaciju",
    settings: "Postavke",
    help: "Pomoć",
    logout: "Odjava",
    login_tips: "Molimo prijavite se",
    msg_fail_title: "Greška",
    msg_fail_update: "Neuspješna izmjena. Pokušajte ponovo",
    msg_loading: "Učitavanje...",
    msg_fail_user:
      "Greška pri dobijanju korisničkih informacija. Želite li pokušati ponovo?",
    edit_profile: "Uredi profil",
    join_us: "Pridruži nam se",
    join_us_details: "Postavite Blitz stanicu u svom objektu"
  },
  msg: {
    appoffline: "Aplikacija još nije pokrenuta, molimo sačekajte",
    deletecard: "Da li ste sigurni da želite obrisati ovu karticu?",
    no_phone: "Broj telefona je obavezan",
    loading: "Učitavanje...",
    title: "Obavijest",
    success: "Uspješna operacija",
    error: "Nepoznata greška. Molimo pokušajte kasnije",
    roleerror: "Nedovoljna ovlaštenja. Obratite se administratoru.",
    neterror: "Neuspješno povezivanje na mrežu. Pokušajte kasnije",
    confirm: "Potvrdi",
    retry: "Pokušaj ponovo",
    cancel: "Otkaži",
    title_fail: "Upozorenje",
    vieworder: "Pogledaj narudžbu",
    success_payment: "Plaćanje završeno",
    success_buy: "Kupovina završena",
    fail_payment: "Neuspješno plaćanje",
    keyword: "Ključna riječ",
    ispayorder: "Molimo potvrdite da li je plaćanje izvršeno",
    unpay: "Neplaćeno",
    yespay: "Plaćeno",
    notopen: "Još nije otvoreno"
  },
  result: {
    tips:
      "Za pregled narudžbi i ostalih lokacija stanica preuzmite aplikaciju.",
    download: "Preuzmi aplikaciju",
    title: "Najam potvrđen",
    gotit: "Razumijem",
    price_plan: "Standard naplate",
    msg_success: "Uspješno iznajmljeno",
    msg_tips_loading: "Power bank se izbacuje, molimo sačekajte...",
    msg_result_loading: "Potvrđivanje rezultata plaćanja...",
    msg_fail_confirm: "Potvrdi",
    btn_usage: "Napomena o korištenju",
    btn_return: "Napomena o vraćanju",
    deposit: "Depozit",
    msg_fail_content: "Zahtjev nije uspio. Molimo pokušajte ponovo.",
    price_label: "po satu",
    price_info:
      "Besplatno prvih {mianfei} minuta. Maksimalna dnevna naknada {ccurrency}{fengding}. Depozit će automatski biti odbijen kada iznos najma dostigne {ccurrency}{yajin}.",
    tips_1:
      "Molimo preuzmite power bank broj {number} kao što je prikazano na slici",
    tips_2:
      "Molimo uredno složite kablove i ubacite power bank u slot s oznakom sa strelicama nadole",
    msg_note_usage:
      "Power bank je opremljen s 3 tipa kablova, odaberite onaj koji odgovara vašem uređaju.",
    msg_note_return:
      "Molimo uredno složite kablove i ubacite power bank u slot sa strane označenom strelicama nadole",
    return_info:
      "Prilikom vraćanja, osigurajte da su kablovi uredno složeni i ubacite stranu s metalnim čipovima u slobodnu utičnicu dok ne dođe do kraja i stabilizuje se.",
    download_tips:
      "Za iznajmljivanje našeg power banka možete odabrati jednu od sljedećih opcija"
  },
  result_msg: {
    loading: "Učitavanje...",
    refresh: "Osvježi"
  },
  order: {
    title: "Istorija iznajmljivanja",
    in_use: "U upotrebi",
    ended: "Završeno",
    msg_error: "Zahtjev nije uspio",
    order_number: "Br.",
    order_details: "Detalji narudžbe",
    order_zj_shop: "Lokacija preuzimanja",
    order_zj_time: "Vrijeme preuzimanja",
    order_gh_shop: "Lokacija vraćanja",
    order_gh_time: "Vrijeme vraćanja",
    order_use_time: "Vrijeme korištenja",
    order_amount: "Ukupan iznos",
    not_on_rent: "Nije iznajmljeno",
    renting: "U najmu",
    undone: "Nedovršeno",
    returned: "Vraćeno",
    questions: "Pitanja",
    timeout_to_return: "Prekoračeno vrijeme vraćanja",
    suspended_for_billing: "Obustavljeno zbog obračuna"
  },
  order_item: {
    order_number: "Br.",
    venue_rented: "Mjesto preuzimanja",
    time_rented: "Vrijeme preuzimanja",
    venue_returned: "Mjesto vraćanja",
    time_returned: "Vrijeme vraćanja",
    charge_standard: "Standard naplate",
    charge_standard_info:
      "{pJifei} {pCurrency} po satu (prvih {pMian} minuta besplatno)",
    rent_occurred: "Najam izvršen",
    returned: "Vraćeno",
    unreturned: "Nije vraćeno",
    type_0: "Nedovršeno",
    type_1: "U najmu",
    type_2: "Otkazano",
    type_3: "Vraćeno",
    type_4: "Došlo do greške",
    type_5: "Prekoračeno vrijeme",
    min: "Min",
    payment: "Plaćanje",
    unpay: "Neplaćeno"
  },
  setting: {
    title: "Postavke",
    lang: "Jezik"
  },
  help: {
    title: "Česta pitanja",
    rentals: "Najmovi",
    venues: "Lokacije",
    payments: "Plaćanja"
  },
  wallet_in: {
    title: "Dopuna balansa",
    price_label: "Iznos dopune",
    price_placeholder: "Unesite iznos dopune",
    balance: "Trenutni balans",
    price_auto: "Odaberite iznos plaćanja",
    price_tips:
      "Vaš balans se može povući na zahtjev. Može potrajati 1–5 radnih dana da sredstva stignu na vaš račun.",
    submit: "Pošalji",
    loading: "Učitavanje...",
    paying: "Preusmjeravanje na stranicu plaćanja...",
    msg_title: "Savjet",
    msg_fail_order: "Neuspješno kreiranje narudžbe za dopunu",
    msg_fail_payment: "Neuspješno pokretanje plaćanja dopune",
    msg_fail_retry: "Pokušaj ponovo"
  },
  wallet_out: {
    title: "Isplata",
    price_label: "Iznos za isplatu",
    price_placeholder: "Unesite iznos isplate",
    balance: "Trenutni balans",
    balance_all: "Isplati sve",
    deposit: "Depozit",
    deposit_tips:
      "Postoji aktivna narudžba najma. Depozit od Ksh{pyajin} nije povratan",
    submit: "Pošalji",
    apply: "Primijeni",
    confirm: "Potvrdi",
    loading: "Učitavanje...",
    msg_fail_price: "Iznos isplate nije ispravan",
    msg_fail_balance: "Iznos isplate ne može biti veći od trenutnog balansa",
    msg_fail_submit: "Molimo popunite sve potrebne podatke",
    msg_title: "Greška",
    msg_success_content: "Isplata uspješna",
    confirmtitle: "Savjet",
    confirmcontent:
      "Trenutni novčanik ne podržava isplatu gotovine. Molimo ostavite kontakt informacije za ručnu obradu povrata",
    payee_name: "Ime primaoca",
    payee_bankcard: "Broj bankovne kartice",
    payee_phone: "Telefon",
    cancelText: "Otkaži",
    confirmText: "Ponovo pošalji zahtjev"
  },
  map: {
    在线: "Otvoreno",
    离线: "Zatvoreno",
    title: "Obližnja stanica",
    result_msg: "U blizini nije pronađena nijedna stanica",
    msg_title: "Greška",
    no_support: "Nažalost, vaš pretraživač ne podržava usluge lokacije",
    my_position: "Moja lokacija",
    distance: "Udaljenost:",
    shop_time: "Radno vrijeme",
    free: "Dostupno za najam",
    return: "Dostupni slobodni slotovi",
    shop_title: "Detalji o lokaciji",
    address: "Adresa",
    go_here: "Idi ovdje",
    nav_help: "Pomoć",
    nav_search: "Pretraga",
    locate: "Lociraj"
  },
  scanQr: {
    NotAllowedError: "Morate omogućiti pristup kameri",
    NotFoundError: "Na ovom uređaju nema kamere",
    NotSupportedError: "Potrebno je sigurno okruženje (HTTPS, localhost)",
    NotReadableError: "Kamera je već u upotrebi",
    OverconstrainedError: "Kamera nije ispravno instalirana",
    StreamApiNotSupportedError: "Ovaj pretraživač ne podržava streaming API"
  },
  payment: {
    payment_title: "Načini plaćanja",
    pay_type: "Molimo dodajte podatke o kartici",
    add_payment_card: "Dodaj platnu karticu",
    add_payment: "dodaj plaćanje"
  },
  shop: {
    title: "Obližnja stanica",
    search_station: "Pretraži stanicu",
    search_station_tips: "Unesite naziv stanice",
    shop_power_banks: "Power bankovi",
    shop_empty_slots: "Slobodni slotovi",
    shop_address: "Adresa",
    shop_business_hours: "Radno vrijeme",
    shop_directions_station: "Upute do stanice",
    shop_scan_qrcode: "Skeniraj QR kod"
  },
  time: {
    days: "Dani",
    hours: "Sati",
    minutes: "Minute"
  }
};
